// extracted by mini-css-extract-plugin
export default {"mainPopBg":"PopUpError_mainPopBg__nxHvU","mainPop":"PopUpError_mainPop__YTG7O","mainPop__inner":"PopUpError_mainPop__inner__O+k7z","buttonBlock":"PopUpError_buttonBlock__+Uc8q"};